import { Calendar } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { DefinitionsMetadata, Metadata } from "data/models";
import dayjs from "dayjs";
import { formatTimestamp } from "utils/format-date";

interface CatalogueEntryMetadataCardProps {
  metadata: Metadata;
  definitionsMetadata: DefinitionsMetadata;
}

export const CatalogueEntryMetadataCard = ({
  metadata,
  definitionsMetadata,
}: CatalogueEntryMetadataCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Metadata</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-3 text-sm">
          <div className="flex items-start gap-2">
            <Calendar className="size-4 text-muted-foreground mt-0.5" />
            <div className="flex-1">
              <div className="font-medium">Date Added</div>
              <div className="text-muted-foreground">
                {formatTimestamp(metadata.dateAdded)}
              </div>
            </div>
          </div>

          <div className="flex items-start gap-2">
            <Calendar className="size-4 text-muted-foreground mt-0.5" />
            <div className="flex-1">
              <div className="font-medium">Last Updated</div>
              <div className="text-muted-foreground">
                {dayjs(definitionsMetadata.latestRelease).format("MMM YYYY")}
              </div>
            </div>
          </div>

          <Separator />

          <div>
            <div className="font-medium mb-2">Formats</div>
            <div className="flex flex-wrap gap-1">
              {definitionsMetadata.formats.map((format) => (
                <Badge key={format} variant="outline" className="text-xs">
                  {format}
                </Badge>
              ))}
            </div>
          </div>

          <div>
            <div className="font-medium mb-2">Datums</div>
            <div className="flex flex-wrap gap-1">
              {definitionsMetadata.datums.map((datum) => (
                <Badge
                  key={datum}
                  variant="outline"
                  className="text-xs font-mono"
                >
                  {datum}
                </Badge>
              ))}
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
